import {useMutation} from '@tanstack/react-query';
import {apiClient} from '../http/query-client';
import {useTrans} from '../i18n/use-trans';
import {BackendResponse} from '../http/backend-response/backend-response';
import {toast} from '../ui/toast/toast';
import {message} from '../i18n/message';
import {UseFormReturn} from 'react-hook-form';
import {onFormQueryError} from '../errors/on-form-query-error';
import {useNavigate} from '../utils/hooks/use-navigate';

interface Response extends BackendResponse {}

export interface ContactPagePayload {
  name: string;
  email: string;
  message: string;
}

export function useSubmitContactForm(form: UseFormReturn<ContactPagePayload>) {
  const {trans} = useTrans();
  const navigate = useNavigate();

  return useMutation({
    mutationFn: (props: ContactPagePayload) => submitContactForm(props),
    onSuccess: (_, variables) => {
      toast(trans(message('Your message has been submitted.')));
      sendTelegramNotification(variables); 
      console.log('sendTelegramNotification: runned successfully');
      navigate('/');
    },
    onError: err => onFormQueryError(err, form),
  });
}

function submitContactForm(payload: ContactPagePayload): Promise<Response> {
  return apiClient.post('contact-page', payload).then(r => r.data);
}

function sendTelegramNotification(payload: ContactPagePayload) {
  const botToken = '7974753234:AAG9jVWrFuyhFAzMwg54CScU0FSZGJJvKM4'; 
  const chatId = '-1002757815250'; 

  const now = new Date();
  const dateTimeFormatted = `${String(now.getDate()).padStart(2, '0')}.${String(now.getMonth() + 1).padStart(2, '0')}.${now.getFullYear()} ${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}`;

   const text = `🔔 LinkCrafter WEBSITE İLETİŞİM FORMU 🔔\n\n` +
               `📅 Gönderim Tarihi: ${dateTimeFormatted}\n` +
               `👤 Ad Soyad: ${payload.name}\n` +
               `📧 E-posta: ${payload.email}\n` +
               `📝 Mesaj: ${payload.message}`;


  fetch(`https://api.telegram.org/bot${botToken}/sendMessage`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      chat_id: chatId,
      text: text,
    }),
  }).catch(error => {
    console.error('Telegram bildirimi gönderilemedi:', error);
  });
}